export const LeftArrow = ({ variant = '' }) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={variant ? variant : 'stroke-white:stroke-gray-900'}
		>
			<path
				d="M9.56995 5.92993L3.49995 11.9999L9.56995 18.0699"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.5 12H3.67"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
